module.exports = __webpack_public_path__ + "static/img/38.5e30759.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pousada/38.jpg
// module id = o1dN
// module chunks = 1